// extracted by mini-css-extract-plugin
export var borderRadius = "_6i-4";
export var large = "_6i-3";
export var logoContainer = "_6i-0";
export var nameLogo = "_6i-2";
export var small = "_6i-1";